import React from 'react';
import { Image, Container, Row, Col, Dropdown } from 'react-bootstrap';
import './HomeView.css';

const HomeView = () => {
  return (
    <>
      <Image className="header" src="/assets/images/header.jpg" />
      <Container>
        <Row className="home-boxes">
          <Col>
            <div className="home-box home-box-gobierno">
              <Image className="home-box-img" src="/assets/images/gobierno.png" />
              <div className="home-box-title home-box-title-gobierno">Gobierno</div>
              <div className="home-box-links">
                <a className="home-box-link" href="/areas">
                  Áreas
                </a>
                <a className="home-box-link" href="/ejecutivo">
                  Ejecutivo
                </a>
                <a className="home-box-link" href="/concejo-deliverante">
                  Concejo Deliberante
                </a>
                <a className="home-box-link" href="/observatorio-vial">
                  Observatorio Vial
                </a>
                <a className="home-box-link" href="/plan-estrategico">
                  Plan Estratégico
                </a>
                <a className="home-box-link" href="/estados-contables">
                  Estados Contables
                </a>
                <a className="home-box-link" href="/sueldos">
                  Sueldos
                </a>
                <a
                  className="home-box-link"
                  href="https://lookerstudio.google.com/u/0/reporting/4475ed75-2afa-4f83-9214-dc80d07a9229/page/p_b6lx6m3ukd"
                  target="_blank"
                  rel="noreferrer"
                >
                  Gestión y Presupuesto
                </a>
              </div>
            </div>
          </Col>
          <Col>
            <div className="home-box home-box-ciudadano">
              <Image className="home-box-img" src="/assets/images/ciudadano.png" />
              <div className="home-box-title home-box-title-ciudadano">Ciudadano</div>
              <div className="home-box-links">
                <a className="home-box-link" href="/solicitud-decretos">
                  Solicitud de Decretos
                </a>
                <a className="home-box-link" href="/consulta-ordenanzas">
                  Consulta de Ordenanzas
                </a>
                <a className="home-box-link" href="/boletines-oficiales">
                  Boletines Oficiales
                </a>
                <a className="home-box-link" href="/seguimiento-vehiculos">
                  Seguimiento de Vehículos
                </a>
                <a
                  className="home-box-link"
                  href="https://docs.google.com/forms/d/e/1FAIpQLScOEfZK_VCln_6vONlTRPQnYfjhc4Ui-YvghyY3CQMsXu7bnw/viewform?pli=1"
                  target="_blank"
                  rel="noreferrer"
                >
                  Denuncias de Medio Ambiente
                </a>
                <a
                  className="home-box-link"
                  href="https://autogestion.produccion.gob.ar/consumidores"
                  target="_blank"
                  rel="noreferrer"
                >
                  Reclamos Defensar del Consumidor
                </a>
              </div>
            </div>
          </Col>
          <Col>
            <div className="home-box home-box-turismo">
              <Image className="home-box-img" src="/assets/images/turismo-home.png" />
              <div className="home-box-title home-box-title-turismo">Turismo</div>
              <div className="home-box-links">
                <a
                  className="home-box-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.villalaangosturaturismo.gob.ar/"
                >
                  Descrubrí
                </a>
                <a
                  className="home-box-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.villalaangosturaturismo.gob.ar/"
                >
                  Organizá
                </a>
                <a
                  className="home-box-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.villalaangosturaturismo.gob.ar/"
                >
                  Explorá
                </a>
                <a
                  className="home-box-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.villalaangosturaturismo.gob.ar/"
                >
                  Disfrutá de VLA y sus eventos
                </a>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="home-links">
          <Col lg="6" xs="12" sm="12">
            <div className="home-link home-link-noticias">
              <Row>
                <Col lg="3" xs="3" sm="3" className="home-link-img">
                  <Image className="home-link-noticias-img" src="/assets/images/empleados.png" />
                </Col>
                <Col>
                  <div className="home-link-title">Acceso Empleados</div>
                  <div className="home-link-button-content">
                    <Dropdown className="home-link-dropdown">
                      <Dropdown.Toggle id="dropdown-basic">INGRESAR</Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          href="https://api.whatsapp.com/send?phone=5492944348430&text="
                          target="_blank"
                          rel="noreferrer"
                        >
                          Certificados Médicos
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="https://api.whatsapp.com/send?phone=5492944241698&text="
                          target="_blank"
                          rel="noreferrer"
                        >
                          Recursos Humanos
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="https://mvla.turecibo.com/e/login"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Recibos
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg="6" xs="12" sm="12">
            <div className="home-link home-link-turismo">
              <Row>
                <Col lg="3" xs="3" sm="3" className="home-link-img">
                  <Image className="home-link-turismo-img" src="/assets/images/noticias.png" />
                </Col>
                <Col>
                  <div className="home-link-title">Enteráte las últimas novedades</div>
                  <div className="home-link-button-content">
                    <a
                      href="https://www.angosturainforma.gob.ar/"
                      target="_blank"
                      rel="noreferrer"
                      className="home-link-button"
                    >
                      Noticias
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default React.memo(HomeView);
